<div class="chart-container">
  <kendo-chart>
    <kendo-chart-legend [visible]="true"></kendo-chart-legend>
    <kendo-chart-area [background]="platformChart.chartAreaBackgroundColor"></kendo-chart-area>
    <kendo-chart-tooltip>
      <ng-template
        kendoChartSeriesTooltipTemplate
        let-value="value"
        let-category="category">
        {{ category }}: {{ value }} {{ constantLabel }}
      </ng-template>
    </kendo-chart-tooltip>
    <kendo-chart-series>
      <kendo-chart-series-item
        [type]="platformChart.chartType"
        [holeSize]="platformChart.holeSize"
        [data]="platformChart.chartItems"
        [categoryField]="platformChart.categoryField"
        [field]="platformChart.field"
        [colorField]="platformChart.colorField">
      </kendo-chart-series-item>
    </kendo-chart-series>
  </kendo-chart>
  <!--<div class="legend">
    <ul>
      <li *ngFor="let item of platformChart.chartItems">
        <span [ngStyle]="{ 'background-color': item.colorCode }"></span>
        <span>{{ item.sourceTitle }}</span>
      </li>
    </ul>
  </div>-->
</div>
